import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function DownloadPdfLoader() {
  return (
    <div>
      <div className="valign-wrapper mb-2">
        <span className="valign-wrapper" style={{ gap: "25px" }}>
          <Skeleton circle={true} height={30} width={30} />
          <Skeleton width={200} height={30} />
        </span>
      </div>
      <div className="white container">
        <div
          className=" valign-wrapper justify-center pdf-section"
          style={{ borderRadius: "0px 0px 75px 75px" }}
        >
          <Skeleton circle={true} height={130} width={130} />
        </div>
        <div className="container flex column gap-1">
          <Skeleton width={300} height={30} />
          <div className="pdf-section">
            <Skeleton width={200} height={30} />
            {Array.from({ length: 5 }).map((_, idx) => (
              <Skeleton
                key={idx}
                width="100%"
                height={20}
                style={{ marginBottom: "0.5rem" }}
              />
            ))}
          </div>
          <div className="mt-1 pdf-section">
            <Skeleton width={200} height={30} />
            {Array.from({ length: 5 }).map((_, idx) => (
              <Skeleton
                key={idx}
                width="100%"
                height={20}
                style={{ marginBottom: "0.5rem" }}
              />
            ))}
          </div>
          <Skeleton width={300} height={30} />
        </div>
        <div
          className=" valign-wrapper space-between mt-2 pdf-section"
          style={{ borderRadius: "75px 75px 0px 0px" }}
        >
          <div className="container valign-wrapper space-between">
            <Skeleton circle={true} height={100} width={100} />
            <Skeleton width={200} height={50} />
          </div>
        </div>
      </div>
      <Skeleton
        circle={true}
        height={30}
        width={30}
        style={{ position: "absolute", top: "100px", right: "240px" }}
      />
    </div>
  );
}

export default DownloadPdfLoader;
